import auth from "../server/auth";
import { setToken as setTokenFB } from "../../../Breeze.FormBuilder.Frontend/helpers/session";

export const initializeToken = async () => {
  const token = getToken();
  if (token) {
    try {
      await setToken(token);
    } catch (error) {
      await setToken("");
    }
  }
};

export const getToken = () => {
  return localStorage.token;
};

export const setToken = async token => {
  localStorage.token = token;
  auth.token(token);
  setTokenFB(token);
};
